export default [
    {
        english_number: "0",
        english_title: "Zero",
        gujarati_audio: "शून्य",
        gujarati_number: "૦",
        gujarati_title: "શૂન્ય",
        hindi_number: "0",
        hindi_title: "शून्य",
    },
    {
        english_number: "1",
        english_title: "One",
        gujarati_audio: "एक",
        gujarati_number: "૧",
        gujarati_title: "એક",
        hindi_number: "१",
        hindi_title: "एक",
    },
    {
        english_number: "2",
        english_title: "Two",
        gujarati_audio: "बे",
        gujarati_number: "૨",
        gujarati_title: "બે",
        hindi_number: "२",
        hindi_title: "दो",
    },
    {
        english_number: "3",
        english_title: "Three",
        gujarati_audio: "त्रण",
        gujarati_number: "૩",
        gujarati_title: "ત્રણ",
        hindi_number: "३",
        hindi_title: "तीन",
    },
    {
        english_number: "4",
        english_title: "Four",
        gujarati_audio: "चार",
        gujarati_number: "૪",
        gujarati_title: "ચાર",
        hindi_number: "४",
        hindi_title: "चार",
    },
    {
        english_number: "5",
        english_title: "Five",
        gujarati_audio: "पाँच",
        gujarati_number: "૫",
        gujarati_title: "પાંચ",
        hindi_number: "५",
        hindi_title: "पाँच",
    },
    {
        english_number: "6",
        english_title: "Six",
        gujarati_audio: "छ",
        gujarati_number: "૬",
        gujarati_title: "છ",
        hindi_number: "६",
        hindi_title: "छे",
    },
    {
        english_number: "7",
        english_title: "Seven",
        gujarati_audio: "सात",
        gujarati_number: "૭",
        gujarati_title: "સાત",
        hindi_number: "७",
        hindi_title: "सात",
    },
    {
        english_number: "8",
        english_title: "Eight",
        gujarati_audio: "आठ",
        gujarati_number: "૮",
        gujarati_title: "આઠ",
        hindi_number: "८",
        hindi_title: "आठ",
    },
    {
        english_number: "9",
        english_title: "Nine",
        gujarati_audio: "नव",
        gujarati_number: "૯",
        gujarati_title: "નવ",
        hindi_number: "९",
        hindi_title: "नौ",
    },
    {
        english_number: "10",
        english_title: "Ten",
        gujarati_audio: "दस",
        gujarati_number: "૧૦",
        gujarati_title: "દસ",
        hindi_number: "१०",
        hindi_title: "दस",
    },
];
